<template>
  <div class="filtre" :class="{ 'filtre--actif': value }" :data-filtre="nom">
    <button type="button" class="filtre__bouton" :aria-expanded="ouvert ? 'true' : 'false'" aria-haspopup="listbox" @click="ouvert = !ouvert">
      <span class="filtre__libelle">{{ libelle }}</span><span v-if="value" class="filtre__valeur"> : {{ libelleChoisi }}</span>
      <span class="filtre__fleche" aria-hidden="true">▾</span>
    </button>
    <button v-if="value" type="button" class="filtre__effacer" :title="'Retirer le filtre ' + libelle" @click="choisir('')">✕</button>
    <ul v-if="ouvert" class="filtre__menu" role="listbox" :aria-label="libelle">
      <li role="option" :aria-selected="!value ? 'true' : 'false'" class="filtre__option" :class="{ 'filtre__option--choisie': !value }" @click="choisir('')">{{ tous }}</li>
      <li v-for="o in options" :key="o.value" role="option" :aria-selected="o.value === value ? 'true' : 'false'"
        class="filtre__option" :class="{ 'filtre__option--choisie': o.value === value }" @click="choisir(o.value)">{{ o.label }}</li>
    </ul>
  </div>
</template>

<script>
/**
 * Bouton de filtre au-dessus d'une liste (12/10/2026) : un clic ouvre les choix, le choix s'applique aussitôt ;
 * filtre actif mis en évidence (« État : Terminées ») avec une croix pour le retirer. v-model : valeur choisie ('' = tous).
 */
export default {
  name: 'FiltreBouton',
  props: {
    value: { type: String, default: '' },
    libelle: { type: String, required: true },
    nom: { type: String, required: true },          // data-filtre, pour les tests
    options: { type: Array, default: () => [] },     // [{ value, label }]
    tous: { type: String, default: 'Tous' },
  },
  data() {
    return { ouvert: false }
  },
  computed: {
    libelleChoisi() {
      const o = this.options.find(x => x.value === this.value)
      return o ? o.label : this.value
    },
  },
  mounted() {
    this.fermerSiDehors = e => { if (this.ouvert && !this.$el.contains(e.target)) this.ouvert = false }
    document.addEventListener('click', this.fermerSiDehors)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.fermerSiDehors)
  },
  methods: {
    choisir(v) {
      this.ouvert = false
      this.$emit('input', v)
    },
  },
}
</script>

<style scoped>
.filtre { position: relative; display: inline-flex; align-items: center; }
.filtre__bouton {
  display: inline-flex; align-items: center; gap: 4px;
  padding: 7px 14px; border: 1px solid #d5d9e0; border-radius: 18px; background: #fff;
  font-size: 13px; font-weight: 600; color: #3a3f4b; cursor: pointer; white-space: nowrap;
}
.filtre__bouton:hover { border-color: #f5c518; }
.filtre__bouton:focus-visible, .filtre__effacer:focus-visible { outline: 2px solid #f5c518; outline-offset: 2px; }
.filtre--actif .filtre__bouton { background: #fff8d6; border-color: #f5c518; padding-right: 30px; }
.filtre__valeur { font-weight: 500; }
.filtre__fleche { font-size: 10px; color: #888; margin-left: 2px; }
.filtre__effacer {
  position: absolute; right: 8px; top: 50%; transform: translateY(-50%);
  border: 0; background: transparent; color: #8a6d00; font-size: 12px; cursor: pointer; padding: 2px 4px;
}
.filtre__menu {
  position: absolute; top: calc(100% + 4px); left: 0; z-index: 50; min-width: 180px; max-height: 280px; overflow-y: auto;
  margin: 0; padding: 4px 0; list-style: none; background: #fff; border: 1px solid #e1e4ea; border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
}
.filtre__option { padding: 7px 14px; font-size: 13px; cursor: pointer; white-space: nowrap; }
.filtre__option:hover { background: #f5f6f8; }
.filtre__option--choisie { font-weight: 700; color: #1a1a2e; }
</style>
